<div
  class="rich-text-editor"
  [ngClass]="{
    'rich-text-editor--disabled': settings.disabled,
    'rich-text-editor--readonly': settings.readonly,
    'rich-text-editor--invalid': isInvalid
  }"
>
  <sgt-toolbar
    *ngIf="!settings.disabled && !settings.readonly"
    [settings]="{
      currentFormat: currentFormat,
      showTextColorPicker: showTextColorPicker,
      showBgColorPicker: showBgColorPicker,
      customTextColor: customTextColor,
      customBgColor: customBgColor
    }"
    (action)="onToolbarAction($event)"
    (mousedown)="preventBlur($event)"
  >
  </sgt-toolbar>

  <div class="rich-text-editor__container">
    <div
      #editor
      class="rich-text-editor__content"
      contenteditable="true"
      (input)="onInput()"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keydown)="onKeyDown($event)"
    ></div>

    <div class="rich-text-editor__content-placeholder" *ngIf="showPlaceholder">
      {{ placeholder }}
    </div>
  </div>
</div>
